import styled from '@emotion/styled';

export const Title = styled.h1`
  margin-bottom: 0px;
`;
